import { render } from "./IconDefault.vue?vue&type=template&id=95c8d300&scoped=true"
import script from "./IconDefault.vue?vue&type=script&lang=js"
export * from "./IconDefault.vue?vue&type=script&lang=js"

import "./IconDefault.vue?vue&type=style&index=0&id=95c8d300&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95c8d300"]])

export default __exports__